import React from "react";
import Layout from "../components/Layout";
import { useParams } from "react-router-dom";

const HackathonStepTwo = () => {
  const { type } = useParams();

  const categories = [
    {
      name: "Code Combat",
      type: "individual",
    },
    {
      name: "Algo Trivia",
      type: "individual",
    },
    {
      name: "Speed programming",
      type: "",
    },
    {
      name: "Speed debugging",
    },
    {
      name: "Algorithm Arena",
    },
    {
      name: "Project-Like Task Programming",
    },
    {},
  ];

  return (
    <Layout>
      <div className="slider-area">
        <div className="single-slider hero-overly slider-height2 slider-bg2 d-flex align-items-center">
          <div className="container">
            <div className="row justify-content-center ">
              <div className="col-xxl-12">
                <div className="hero-caption hero-caption2">
                  <br />
                  <br />
                  <h2>
                    Registration - Hackathon
                    <br /> {type}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="container p-4 pt-0 mt-0"></section>
    </Layout>
  );
};

export default HackathonStepTwo;
